<ng-template #savingsWidget>
  <bp-tile
    [ngClass]="{ card: !!tradable }"
    [showHeader]="true"
    [title]="'savings' | translate"
    color="default"
    [padding]="false"
    [placement]="'bottom'">
    <!--    Button Action -Manage- has to be the first entity after bp-tile declaration to be recognized as a tile-action-->
    <a class="button-weight btn_manage" tile-actions [routerLink]="['/my-account/savings']" [tabIndex]="0">
      {{ "savings_widget_manage_plans_button" | translate }}
    </a>
    @if (showSavingsList$ | async) {
      <savings-list></savings-list>
      <div class="justify-center">
        <button class="btn_savings btn btn-primary" (click)="addNewSavingsPlan()" (keydown.enter)="addNewSavingsPlan()">
          {{ "savings_plan_with_plans_create_new" | translate }}
        </button>
      </div>
    } @else {
      <savings-empty [tradable]="tradable"></savings-empty>
    }
    <!-- empty state for ADP page -->
  </bp-tile>
</ng-template>
<ng-container *ngTemplateOutlet="savingsWidget"></ng-container>
